import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import getInitials from '@medflex/utils/getInitials';

import Avatar from '../Avatar';
import Tooltip from '../Tooltip';

const AssigneeAvatar = ({ assignee }) => {
  const { t } = useTranslation('components');
  const user = assignee.attributes || assignee;
  const initials = getInitials(user);
  const displayName = getFullNameWithTitle(user);

  return (
    <Tooltip
      className="truncate max-w-[350px]"
      title={`${t('PamInquiry.assignedTo')} ${displayName}`}
    >
      <div className="flex">
        <Avatar src={user.avatar} initials={initials} size="6" />
      </div>
    </Tooltip>
  );
};

AssigneeAvatar.propTypes = {
  assignee: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    attributes: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      avatar: PropTypes.string,
      email: PropTypes.string,
      title: PropTypes.string,
    }),
  }).isRequired,
};

export default AssigneeAvatar;
